var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "scanClass" },
              [
                _c("span", { staticClass: "redClass" }, [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.returnRegistration"))),
                ]),
                _c("el-input", {
                  staticClass: "iconBtn",
                  attrs: {
                    placeholder: _vm.$t("collectionCenter.PleaseScan"),
                    clearable: "",
                    "prefix-icon": "el-icon-full-screen",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.addTable($event)
                    },
                  },
                  model: {
                    value: _vm.waybillNumber,
                    callback: function ($$v) {
                      _vm.waybillNumber =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "waybillNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "scanClass" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.returnPoint"))),
                ]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: _vm.$t("collectionCenter.pleaseChoose"),
                      clearable: "",
                      filterable: "",
                    },
                    on: { focus: _vm.getNewestSite },
                    model: {
                      value: _vm.siteId,
                      callback: function ($$v) {
                        _vm.siteId = $$v
                      },
                      expression: "siteId",
                    },
                  },
                  _vm._l(_vm.siteIdList, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-button",
            {
              staticClass: "onlyClickOnce",
              attrs: { type: "primary" },
              on: { click: _vm.upload },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.Upload")) + " ")]
          ),
        ],
        1
      ),
      _c("el-card", [
        _c(
          "div",
          { staticClass: "tableClass" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.scanData, "max-height": 600, border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("operatingPlatform.waybillNumber"),
                    align: "center",
                    prop: "waybillNumber",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("operatingPlatform.scanTime"),
                    align: "center",
                    prop: "scanTime",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("operatingPlatform.operation"),
                    align: "center",
                    fixed: "right",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popconfirm",
                            {
                              attrs: {
                                title: _vm.$t("operatingPlatform.deleteSure"),
                              },
                              on: {
                                confirm: function ($event) {
                                  return _vm.scanDelClick(
                                    scope.row,
                                    scope.$index
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "mini",
                                    type: "danger",
                                  },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("operatingPlatform.Delete"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }